module.exports = __webpack_public_path__ + "static/media/fire.b5cf779b.png";